
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hs7Sl", function(module, exports) {

$parcel$export(module.exports, "ConsentBannerWrapper", () => $12d57fb9dae056e4$export$e809c952bdb1ec4c);

var $gwFzn = parcelRequire("gwFzn");

var $eqCNB = parcelRequire("eqCNB");

var $luv00 = parcelRequire("luv00");
const $12d57fb9dae056e4$export$e809c952bdb1ec4c = ({ ...props })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ...ssrPlaceholderIdProp,
        "data-vc": "consent-banner-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eqCNB.ConsentBanner), props));
};

});


//# sourceMappingURL=ConsentBannerWrapper.ec9bc5b3.js.map
